import { type SVGProps } from "react"

export function Connector3(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={138}
            height={299}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M.5 295v-7.82a2 2 0 1 1 4 0V291h4.03a2 2 0 1 1 0 4zm28.13 0H16.57a2 2 0 1 1 0-4h12.06a2 2 0 1 1 0 4m20.1 0H36.67a2 2 0 1 1 0-4h12.06a2 2 0 1 1 0 4m20.1 0H56.77a2 2 0 1 1 0-4h12.06a2 2 0 1 1 0 4m20.1 0H76.87a2 2 0 1 1 0-4h12.06a2 2 0 1 1 0 4m14.07 0h-6.03a2 2 0 1 1 0-4H103a2 2 0 1 1 0 4M2.5 281.42a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2v-11.64a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2V93.18a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2V73.78a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2V54.38a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2V34.98a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2V15.58a2 2 0 1 1 4 0v11.64a2 2 0 0 1-2 2m0-19.4a2 2 0 0 1-2-2V0h7.7a2 2 0 1 1 0 4H4.5v3.82a2 2 0 0 1-2 2M137.5 2a2 2 0 0 1-2 2h-5.7a2 2 0 1 1 0-4h5.7a2 2 0 0 1 2 2m-13.3 0a2 2 0 0 1-2 2h-11.4a2 2 0 1 1 0-4h11.4a2 2 0 0 1 2 2m-19 0a2 2 0 0 1-2 2H91.8a2 2 0 1 1 0-4h11.4a2 2 0 0 1 2 2m-19 0a2 2 0 0 1-2 2H72.8a2 2 0 1 1 0-4h11.4a2 2 0 0 1 2 2m-19 0a2 2 0 0 1-2 2H53.8a2 2 0 1 1 0-4h11.4a2 2 0 0 1 2 2m-19 0a2 2 0 0 1-2 2H34.8a2 2 0 1 1 0-4h11.4a2 2 0 0 1 2 2m-19 0a2 2 0 0 1-2 2H15.8a2 2 0 1 1 0-4h11.4a2 2 0 0 1 2 2"
                clipRule="evenodd"
            />
            <circle
                cx={116}
                cy={293}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}
